const TEMPLATE_EXAMPLE = {
  name: 'Maria Silva',
  phone: '5551999887766',
  information: 'Lead feira SP',
  nicho: 'Alimentação',
  user: 1,
};

const CSV_HEADERS = ['name', 'phone', 'information', 'nicho', 'user'];

function downloadBlob(filename, content, mimeType) {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function downloadCsvTemplate() {
  const csv = [
    CSV_HEADERS.join(','),
    `${TEMPLATE_EXAMPLE.name},${TEMPLATE_EXAMPLE.phone},${TEMPLATE_EXAMPLE.information},${TEMPLATE_EXAMPLE.nicho},${TEMPLATE_EXAMPLE.user}`,
  ].join('\n');
  downloadBlob('atendabot-prospects-template.csv', csv, 'text/csv;charset=utf-8');
}

export function downloadJsonTemplate() {
  const json = JSON.stringify([TEMPLATE_EXAMPLE], null, 2);
  downloadBlob('atendabot-prospects-template.json', json, 'application/json;charset=utf-8');
}

function parseCsvLine(line) {
  const values = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];
    const next = line[i + 1];

    if (char === '"' && inQuotes && next === '"') {
      current += '"';
      i += 1;
      continue;
    }

    if (char === '"') {
      inQuotes = !inQuotes;
      continue;
    }

    if (char === ',' && !inQuotes) {
      values.push(current.trim());
      current = '';
      continue;
    }

    current += char;
  }

  values.push(current.trim());
  return values;
}

function parseUserValue(value) {
  if (value == null || value === '') return '';
  return String(value).trim();
}

export function parseProspectsCsv(text) {
  const lines = String(text || '')
    .replace(/^\uFEFF/, '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length < 2) {
    throw new Error('CSV deve ter cabeçalho e ao menos uma linha de dados.');
  }

  const headers = parseCsvLine(lines[0]).map((h) => h.toLowerCase());
  const missing = CSV_HEADERS.filter((h) => !headers.includes(h));
  if (missing.length) {
    throw new Error(`CSV inválido. Colunas obrigatórias: ${CSV_HEADERS.join(', ')}.`);
  }

  const nameIdx = headers.indexOf('name');
  const phoneIdx = headers.indexOf('phone');
  const infoIdx = headers.indexOf('information');
  const nichoIdx = headers.indexOf('nicho');
  const userIdx = headers.indexOf('user');

  return lines.slice(1).map((line) => {
    const cols = parseCsvLine(line);
    return {
      name: cols[nameIdx] || '',
      phone: cols[phoneIdx] || '',
      information: cols[infoIdx] || '',
      nicho: cols[nichoIdx] || '',
      user: parseUserValue(cols[userIdx]),
    };
  });
}

export function parseProspectsJson(text) {
  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch (_err) {
    throw new Error('JSON inválido.');
  }

  if (!Array.isArray(parsed)) {
    throw new Error('JSON deve ser um array de objetos.');
  }

  return parsed.map((item) => ({
    name: item?.name != null ? String(item.name) : '',
    phone: item?.phone != null ? String(item.phone) : '',
    information: item?.information != null ? String(item.information) : '',
    nicho: item?.nicho != null ? String(item.nicho) : '',
    user: parseUserValue(item?.user),
  }));
}

export async function parseProspectsFile(file) {
  if (!file) throw new Error('Selecione um arquivo.');

  const text = await file.text();
  const name = String(file.name || '').toLowerCase();

  if (name.endsWith('.csv') || file.type === 'text/csv') {
    return parseProspectsCsv(text);
  }

  if (name.endsWith('.json') || file.type === 'application/json') {
    return parseProspectsJson(text);
  }

  throw new Error('Formato não suportado. Use .csv ou .json.');
}
